import microuniversoApi from 'app/api/microuniversoApi'
import { tratamentoErroPadrao } from 'app/use-cases/tratamentoErroPadrao'
import { Dict } from 'app/utils/Dict'
import globalMU from 'globalMU'
import React, { useEffect, useRef } from 'react'
import { Breadcrumb2Container } from '../breadcrumb2/Breadcrumb2Container'
import { Separador } from '../separador/Separador'
import { SolicitarSenha } from './SolicitarSenha'

type SolicitarSenhaContainerProps = {
    permissao: string,
    dicaPermissao?: string,
    textoAdicional?: string,
    onSenhaValidada: (senhaValida: boolean, senha?: string) => void,
    onRemover: () => void,
    onVoltar: () => void,
    exibirBotaoVoltar: boolean,
    passos: Dict<string, () => void>
}

const SolicitarSenhaContainer = (props: SolicitarSenhaContainerProps) => {
    const passosInterno = useRef<Dict<string, () => void>>(new Dict(Object.assign({}, props.passos?.map)))
    
    const validarSenha = async (senha: string) => {
        globalMU.blockUI()
        try {
            const senhaValida = await microuniversoApi.Orcamento.validarSenha(senha, props.permissao)
            if (!senhaValida) {
                globalMU.showErrorMessage("Senha inválida")
                return
            }
            if(senhaValida?.HasErrors)
                return

            props.onSenhaValidada(senhaValida, senha)
        } catch (error) {
            tratamentoErroPadrao(error)
            props.onSenhaValidada(false)
        } finally {
            globalMU.unblockUI()
        }
    }

    const onVoltar = () => {
        props.onRemover()
        props.onVoltar()
    }

    const onPassoSelecionado = (passo: string) => {
        props.onRemover()
        props.passos?.get(passo)()
    }
/*
    useEffect(() => {
        passosInterno.current.set("Simulação de Preço", () => { })
    }, [])
*/
    return <>
        <Breadcrumb2Container
            passos={passosInterno.current.keysToList()}
            exibirBotaoLimpar={false}
            exibirBotaoVoltar={props.exibirBotaoVoltar} // 450413
            id="SolicitarSenhaContainer"
            onPassoSelecionado={onPassoSelecionado}
            onBotaoVoltarClicado={onVoltar}
        />
        {props.exibirBotaoVoltar &&
        <Separador />
        }
        {props.textoAdicional && props.textoAdicional != "" 
            && <p id="SolicitarSenha_textoAdicional"
            style={{ color: "var(--mu-azul-marcador, blue)", fontWeight: "bold", }}
            >{props.textoAdicional}</p>}
        <SolicitarSenha
            dicaPermissao={props.dicaPermissao}
            onSenhaInformada={validarSenha} />
    </>
}

export {
    SolicitarSenhaContainer,
    SolicitarSenhaContainerProps
}

